const window = require('window');
const Backbone = require('backbone');
const externalScriptLoader = require('externalScriptLoader');

module.exports = Backbone.View.extend({
	/**
	 * @returns {void}
	 */
	initialize: function() {
		externalScriptLoader(`${window.dataLayer.bvUrl}`.replace('%s', window.dataLayer.bvDeploymentZone), () => {
			this._fireConversion();
		});
	},

	/**
	 * @private
	 * @returns {void}
	 */
	_fireConversion: function() {
		const receipt = window.dataLayer.receipt,
			items = receipt.cart.items.map(
				function(item) {
					return {
						sku: item.uniqueId,
						name: `${item.manufacturer} ${item.productId} ${item.title}`,
						price: this._toFixed(item.unitPrice),
						quantity: item.quantity,
						imageURL: item.image
					};
				}.bind(this)
			);

		window.$BV.SI.trackTransactionPageView({
			orderId: receipt.orderNumber,
			tax: this._toFixed(receipt.taxTotal),
			shipping: this._toFixed(receipt.shippingTotal),
			total: this._toFixed(receipt.grandTotal),
			city: receipt.billingAddress.city,
			state: receipt.billingAddress.state,
			country: receipt.billingAddress.countryId === 1 ? 'US' : 'CA',
			nickname: receipt.billingAddress.firstName,
			currency: 'USD',
			items: items,
			email: receipt.email,
			locale: 'en_US'
		});
	},

	/**
	 * @param {number} value
	 * @returns {string}
	 */
	_toFixed: function(value) {
		return (value || 0).toFixed(2);
	}
});
